import { render, staticRenderFns } from "./prefooter-white.vue?vue&type=template&id=6f60cb3c&"
import script from "./prefooter-white.vue?vue&type=script&lang=js&"
export * from "./prefooter-white.vue?vue&type=script&lang=js&"
import style0 from "./prefooter-white.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports